import { EMAIL_STATUS } from './constants'
import { timezoneDate } from 'utils/helpers'

export const toEmails = emails =>
  emails.map(email => ({
    date: email.attemptDate ? timezoneDate(email.attemptDate) : EMAIL_STATUS[email.status],
    time: email.attemptDate
      ? timezoneDate(email.attemptDate, 'hh:mm A')
      : EMAIL_STATUS[email.status],
    sentDate: email.sentDate ? timezoneDate(email.sentDate) : EMAIL_STATUS[email.status],
    sentTime: email.sentDate ? timezoneDate(email.sentDate, 'hh:mm A') : EMAIL_STATUS[email.status],
    status: EMAIL_STATUS[email.status],
    contact: email.contact,
    company: email.company,
    companyNoBid: email.companyNoBid,
    subjectLine: email.subjectLine,
    dealName: email.dealName || '---',
    proposalName: email.proposalName,
    sentTo: email.sentTo,
    error: email.error || '---'
  }))
